//recipeId, orgamizationId
import { array, struct } from 'io-ts/Decoder';

import { Id as RecipeId } from '../../../../whole-house/recipe/Id';

export const Request = struct({
	recipeIds: array(RecipeId),
});
